<div
  class="wrapper"
  [ngClass]="{
    'is-desktop': !isMobile,
    guest,
    z2: !!openModal || (!!openAuthModal && !homeScreen),
    external: !!urlSlug === true && enableExternal
  }"
>
  <div class="logos">
    <!-- <a
      [routerLink]="
        (urlSlug$ | async) && !(organizationError | async)
          ? '/o/' + (urlSlug$ | async)
          : '/'
      "
      class="logo"
    > -->
    <a routerLink="/" class="logo">
      <img
        *ngIf="!!urlSlug === false || !enableExternal"
        src="/assets/images/logo.png"
        alt="logo"
      />
      <img
        *ngIf="!!urlSlug === true && enableExternal"
        src="/assets/images/logo-white.png"
        alt="logo"
      />
    </a>
    <!-- <a
      [routerLink]="
        (urlSlug$ | async) && !(organizationError | async)
          ? '/o/' + (urlSlug$ | async)
          : '/'
      "
      class="twnsqr"
    > -->
    <!-- <a routerLink="/" class="twnsqr">
      <img src="assets/images/TwnSqr_horizontal_color.svg" alt="twnsqr_logo" />
    </a> -->
  </div>

  <div class="links">
    <app-menu-mobile
      class="mobile-menu"
      [open]="open"
      [guest]="guest"
      [links]="links"
      (closeMenu)="open = false"
    ></app-menu-mobile>
    <ul>
      <app-submit-a-deal-button
        [wrapper]="submitDealWrapper"
      ></app-submit-a-deal-button>
      <ng-template #submitDealWrapper let-text let-handleClick="handleClick">
        <li
          class="custom-btn"
          (click)="handleClick()"
          [ngClass]="{
            external: !!urlSlug === true && enableExternal
          }"
        >
          {{ text }}
        </li>
      </ng-template>

      <li
        *ngFor="let item of links; let i = index; trackBy: trackByFn"
        [matMenuTriggerFor]="item.children ? menu : null"
      >
        <a
          [href]="item.path"
          [target]="
            item.title === 'Rebuilt Marketplace'
              ? urlSlug
                ? '_blank'
                : '_self'
              : '_blank'
          "
          (click)="preventDefault($event, item)"
          [ngClass]="{
            external: !!urlSlug === true && enableExternal
          }"
        >
          {{ item.title }}
          <app-shared-icon
            *ngIf="item.children"
            [name]="guest ? 'chevron-down-white' : 'chevron-down'"
            [size]="10"
            class="icon"
          ></app-shared-icon>
          <app-shared-icon
            *ngIf="item.children && !guest"
            name="chevron-down-blue"
            [size]="10"
            class="icon-active"
          ></app-shared-icon>
        </a>
        <mat-menu #menu="matMenu">
          <a
            *ngFor="let child of item.children"
            [href]="child.path"
            target="_blank"
          >
            {{ child.title }}</a
          >
        </mat-menu>
      </li>
    </ul>
  </div>

  <div class="flex items-center justify-end gap-x-4">
    <app-help-msg-button *ngIf="!propertyDetailsScreen"></app-help-msg-button>

    <app-user-notifications-bell
      [external]="!!urlSlug === true && enableExternal"
    ></app-user-notifications-bell>

    <app-topbar-user
      class="user-dropdown"
      [externalOrg]="!!urlSlug && enableExternal"
    ></app-topbar-user>

    <div class="mobile-icon" (click)="open = !open">
      <app-shared-icon
        *ngIf="guest || !!urlSlug"
        name="menu-white"
      ></app-shared-icon>
      <app-shared-icon *ngIf="!guest && !urlSlug" name="menu"></app-shared-icon>
    </div>
  </div>
</div>
